import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MainRroutes from "./routes/main-routes";

function App() {
  return (
    <main className="bg-lightBg h-[100vh]">
      <MainRroutes />
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </main>
  );
}

export default App;
